import SceneListPage from './SceneListPage.container'

export default SceneListPage
